import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { HELPSCOUT_BEACON_PAGE } from "common/constants";
import { buildLink } from "common/routing";
import Logo from "../../images/logo-white.svg";
import { spacing } from "../../stitches.config";
import { setTitle } from "../../utils/title";
import { EmptyState } from "../Common/EmptyState";
import { Page } from "./__styles__/Layout";
import { StyledHeader } from "./__styles__/UnavailablePage";
import { PublicBanner } from "./PublicBanner";
import { useHelpscoutBeacon } from "./utils";

const UnavailablePage = () => {
  const history = useHistory();
  const { t } = useTranslation();
  useHelpscoutBeacon(HELPSCOUT_BEACON_PAGE.NOT_FOUND);
  setTitle(t("tab-page-unavailable"));

  return (
    <Page>
      <PublicBanner />
      <Header />
      <div style={{ marginTop: spacing["3xl"].value }}>
        <EmptyState
          body={t("page-unavailable-subtext")}
          title={t("page-unavailable-header")}
          icon="missing-location"
          primaryButtonProps={{
            label: t("page-unavailable-button-contact"),
            onClick: () => history.push(buildLink("getHelp")),
          }}
        />
      </div>
    </Page>
  );
};

const Header = () => {
  return (
    <StyledHeader>
      <div>
        <img src={Logo} />
      </div>
    </StyledHeader>
  );
};

export default UnavailablePage;
